// extracted by mini-css-extract-plugin
export default {"xs":"0","sm":"576px","md":"768px","lg":"992px","xl":"1200px","xxl":"1350px","cm":"1267px","spacer":"1rem"};